var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"preloader"},[_c('svg',{staticClass:"preloader__logo"},[_c('use',{attrs:{"xlink:href":"#glyph--wais-logo","href":"#glyph--wais-logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }